import { PositionDTO } from '../../http/dtos/positions/positionsDTO';
import httpClient from '../../http/httpClient';

export const positionsRepository = {
    GetPositionsList: () => {
        return httpClient
            .get('/positions')
            .then((response: PositionDTO[]) => response);
    },
};
